import { createFileRoute } from "@tanstack/react-router";
import { SiteShell } from "@/project/components/site-shell";
import { leaders } from "@/project/data/sample";

export const Route = createFileRoute("/leadership")({
  head: () => ({
    meta: [
      { title: "Leadership & Trustees — Daan Amrut Foundation" },
      { name: "description", content: "Meet the trustees and team leading Daan Amrut Foundation across seven initiatives." },
      { property: "og:title", content: "Leadership — Daan Amrut Foundation" },
      { property: "og:description", content: "Trustees, CEO and initiative leads of Daan Amrut Foundation." },
    ],
  }),
  component: Page,
});

function Page() {
  return (
    <SiteShell>
      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6">
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[var(--saffron-deep)]">Leadership</p>
        <h1 className="mt-2 font-display text-4xl font-semibold text-[var(--maroon-deep)] sm:text-5xl">The trustees & team behind Daan Amrut</h1>
        <p className="mt-3 max-w-2xl text-foreground/70">
          A board of six trustees and a full-time team of 24 across Ahmedabad, Vadodara and Surat — supported by
          1,850+ volunteers on the ground.
        </p>
        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {leaders.map((l) => (
            <div key={l.name} className="rounded-2xl border border-border/60 bg-card p-6 shadow-[var(--shadow-soft)]">
              <div className="flex items-center gap-4">
                {l.photo ? (
                  <img src={l.photo} alt={l.name} loading="lazy" className="h-20 w-20 shrink-0 rounded-full object-cover object-[50%_15%] ring-2 ring-[var(--saffron)]/40 shadow-xs" />
                ) : (
                  <div className="grid h-16 w-16 place-items-center rounded-full bg-[var(--maroon)] font-display text-xl font-semibold text-[var(--cream)]">{l.initials}</div>
                )}
                <div>
                  <p className="font-display text-lg font-semibold text-[var(--maroon-deep)]">{l.name}</p>
                  <p className="text-xs font-semibold text-[var(--saffron-deep)] uppercase tracking-wide">{l.role}</p>
                </div>
              </div>
              <p className="mt-4 text-sm text-foreground/70">{l.bio}</p>
            </div>
          ))}
        </div>
      </section>
    </SiteShell>
  );
}